// Use timeline graph plotting as default.
const graphsInitStatus: any = {
  expanded: true,
  expandedGraphName: 'timeline',
};

// Modify expanded view to mini view and vice-versa.
const viewChangeReducer = (state: any, action: any) => {
  switch (action.type) {
    case 'changeExpandedView':
      return { ...state, expanded: !state.expanded };
    case 'setExpandedGraphDetails':
      return { ...state, ...action.payload };
    default:
      return { ...state };
  }
};

export { viewChangeReducer, graphsInitStatus };
